import { createRoot } from "react-dom/client";
import { useRef, useState, useEffect } from 'react';
import Modal from '@/react/libraries/Modal';
import axios from "axios";
import anime from "animejs";
import ToasterWrapper from '@/react/components/ToasterWrapper';
const { toast } = ToasterWrapper

const Page = ()=>{
	const modalRef = useRef(null);
	const [domains, setDomains] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [modalInputValue, setModalInputValue] = useState('');
	const [domainId, setDomainId] = useState(null);
	const [openDropdownId, setOpenDropdownId] = useState(null);

	useEffect(() => {
        fetchDomains();
    }, []);


    async function fetchDomains() {
    	const url = `${BASE_URL}organization/email-domains`
        try {
            const res = await axios.get(url, { headers: HEADER_OBJ });
            setDomains(res.data);
        } catch (err) {
        	toast.error("Error fetching domains:", err);
        }
    }

    const handleDelete= async (id)=>{
    	const url = `${BASE_URL}organization/email-domains/${id}`

		Swal.fire({
			title: `Do you want to delete this domain?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: `Confirm`,
		}).then((result) => {
			if (result.isConfirmed) {
				axios.delete(url,
				 {
					headers: HEADER_OBJ,
				}).then(res => {
					toast.success(`This domain has been deleted successfully.`);
				}).catch(err => {
					toast.error('An error occurred')
				}).finally(() => {
					fetchDomains();
				})
			}
		})
	}

	const checkDomain =(value)=>{
		const regex = /^[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
		if(regex.test(value)){
			return true;
		}else{
			return false;
		}
	}

    async function submitDomain() {
    	const url = `${BASE_URL}organization/email-domains`
    	if(checkDomain(inputValue)){
	        try {
	        	axios.post(url,
				{ 
					domain: inputValue 
				}, { 
					headers: HEADER_OBJ 
				}).then(res => {
					if(res.data.status === true)
						toast.success(res.data.message);
					else{
						toast.error(res.data.message);
					}
				}).catch(err => {
					toast.error(err.response.data.message);
				}).finally(() => {
					fetchDomains();
					setInputValue('');
				})
	        } catch (err) {
	            toast.error("Error fetching domains:", err);
	        }
    	}else{
    		toast.error("Please type a valid domain. i.e test.com");
    	}
    }

    const checkMatched=(val)=>{
    	const isMatched = domains.some(item=> item.domain == inputValue)
    	return isMatched;
    }

    const handleDomainAdd=()=>{
    	if(!checkMatched(inputValue))
    		submitDomain();
    	else
    		toast.error("The domain has already been taken.");
    }

    const updateDomain=async ()=>{
    	const url = `${BASE_URL}organization/email-domains/${domainId}`
    	if(checkDomain(modalInputValue)){
	    	try{
		    	axios.put(url,
				{ 
					domain: modalInputValue 
				}, { 
					headers: HEADER_OBJ 
				}).then(res => {
					if(res.data.status === true)
						toast.success(res.data.message);
					else{
						toast.error(res.data.message);
					}
				}).catch(err => {
					toast.error(err.response.data.message);
				}).finally(() => {
					fetchDomains();
					setModalInputValue('');
		    		modalRef.current?.closeModal();
				})
	    	}catch(e){
	    		toast.error("Error fetching domains:", e);
	    	}
    	}else{
    		toast.error("Please type a valid domain. i.e test.com");
    	}
    }

	return(
		<>
			<div className="flex flex-col gap-2">
        		<label className="text-label font-medium">Add email domains</label>
        		<div className="flex gap-3 max-w-[500px]">
	        		<div className="input-field flex gap-1.5">
	        			<span className="text-grey-text">@</span>
	        			<input className="w-full" onChange={(e)=> setInputValue(e.target.value)} type="text" name="domain" value={inputValue} />
	        		</div>
        			<button onClick={handleDomainAdd} type="button" className="btn btn-outline-primary add-domain font-normal p-0 text-[35px]"><span className="material-symbols-rounded">add</span></button>
        		</div>
        	</div>

        	<div className="flex flex-col gap-3 max-w-[700px]">
        		<h5 className="text-sub2 font-medium">Allowed/Added email domains</h5>
        		<div className="[&>div]:border-b-thin">
        			{
        				domains.length > 0 ? domains.map((domain, index)=>(
        					<List key={index} isOpen={openDropdownId == domain.id} setModalInputValue={setModalInputValue} setDomainId={setDomainId} setOpenDropdownId={setOpenDropdownId} handleDelete={handleDelete} data={domain} modalRef={modalRef} />
        				))
        				: ( <p className="text-grey-text">You do not have any allowed/added email domains.</p>)
        			}
        		</div>
        	</div>

        	<Modal ref={modalRef} className={`modal__content-wrapper p-2 `}>
				<div className="modal__content-wrapper-header">
					<h2>Edit domain</h2>
				</div>
				<div className="modal__content-wrapper-body">
					<div className="flex flex-col gap-2">
						<label className="text-label font-medium" htmlFor="edit-domain">Change domain</label>
						<div className="input-field flex gap-1.5">
							<span className="text-grey-text">@</span>
							<input onChange={(e)=> setModalInputValue(e.target.value)} id="edit-domain" type="text" name="edit-domain" className="form-required w-full" placeholder="x" value={modalInputValue} />
						</div>
					</div>
				</div>
				<div className="modal__content-wrapper-footer">
					<button className='btn' onClick={updateDomain}>Update</button>
				</div>
			</Modal>
		</>
	)
}

const List =({ data, isOpen, setOpenDropdownId, setModalInputValue, setDomainId, modalRef, handleDelete })=>{
	const dropdownRef = useRef(null);

	const handleToggle = (e) => {
	    e.stopPropagation();
	    if (!isOpen) {
	      	setOpenDropdownId(data.id);
	      	setModalInputValue(data.domain);
	      	setDomainId(data.id);
	    } else {
	      	closeDropdownAnimation();
	    }
	};

	const closeDropdownAnimation = () => {
	    if (!dropdownRef.current) return;

	    anime({
	      targets: dropdownRef.current,
	      scale: 0,
	      opacity: 0,
	      duration: 300,
	      easing: "easeInOutExpo",
	      complete: () => setOpenDropdownId(null),
	    });
	};

	useEffect(() => {
	    if (isOpen && dropdownRef.current) {
	      	dropdownRef.current.style.transformOrigin = "top right";
		    anime({
		        targets: dropdownRef.current,
		        scale: [0, 1],
		        opacity: [0, 1],
		        duration: 300,
		        easing: "easeInOutExpo",
		    });
	    }
	}, [isOpen]);

	// Close dropdown when clicking outside
	useEffect(() => {
	    const handleClickOutside = (e) => {
	      	if (isOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
	        	closeDropdownAnimation();
	      	}
	    };
	    document.addEventListener("click", handleClickOutside);
	    return () => document.removeEventListener("click", handleClickOutside);
	}, [isOpen]);

	return(
		<div className="flex justify-between items-center py-2">
			<div className="flex items-center gap-1.5">
				<span className="text-grey-text">@</span>
				<span>{data.domain}</span>
			</div>
			<div className="w-max" data-dropdown>
                <span onClick={handleToggle} className="material-symbols-rounded cursor-pointer text-grey-text text-sub hover:text-primary transition-all">more_vert</span>
                {
                	isOpen && (
		                <div ref={dropdownRef} data-dropdown-list className="right-[-7px]">
		                    <div className="flex flex-col gap-4 p-1">
		                    	<a onClick={()=>modalRef.current?.openModal()} className="flex items-center gap-3 w-full whitespace-nowrap font-medium cursor-pointer hover:text-primary [&:hover>span]:text-primary transition-all">
				                    <span className="font-normal fk-icons text-label text-grey-text">edit</span> Edit
				                </a>
				                <a onClick={()=> handleDelete(data.id)} className="flex items-center gap-3 w-full whitespace-nowrap font-medium cursor-pointer hover:text-primary [&:hover>span]:text-primary transition-all">
				                    <span className="font-normal fk-icons text-label text-grey-text">delete</span> Delete this domain
				                </a>
		                    </div>
		                </div>
                	)
                }
            </div>
		</div>
	)
}

function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;